import { SvgChevronDown, SvgChevronRight } from "@itwin/itwinui-icons-react"
import { FileIcon } from "../file-icon/FileIcon"
import { FieldDataNode, TreeNodeProps } from "rc-tree"
import { ExplorerDataNode } from "./treeDataManipulation"

export const FileExplorerIcon = ({ options }: { options: TreeNodeProps<FieldDataNode<ExplorerDataNode>> }) => {
  if (options.isLeaf) {
    return <FileIcon filePath={options.title as string} />
  }
  if (options.expanded) {
    return <SvgChevronDown />
  }
  return <SvgChevronRight />
}
